import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { BeaconRegionDTO } from "../beacon-regions/BeaconRegion";

const PATH = "beacon-regions";

@Injectable({
  providedIn: "root",
})
export class BeaconRegionsHandlerService {
  constructor(private APIService: ApiService) {}

  getBeaconRegions(
    masterAccountID: number,
    queryParams?: { facility_id?: number[]; page?: number; perPage?: number },
  ) {
    return this.APIService.get(`${PATH}/${masterAccountID}`, {
      params: queryParams,
    });
  }

  getBeaconRegion(masterAccountID: number, beaconID: number) {
    return this.APIService.get(`${PATH}/${masterAccountID}/${beaconID}`);
  }

  deleteBeaconRegion(masterAccountID: number, beaconID: number) {
    return this.APIService.delete(`${PATH}/${masterAccountID}/${beaconID}`);
  }

  postBeaconRegion(masterAccountID: number, beaconDTO: BeaconRegionDTO) {
    return this.APIService.post(`${PATH}/${masterAccountID}`, beaconDTO);
  }

  putBeaconRegion(masterAccountID: number, beaconDTO: BeaconRegionDTO) {
    return this.APIService.put(
      `${PATH}/${masterAccountID}/${beaconDTO.id}`,
      beaconDTO,
    );
  }
}
